var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 14.6663H4.66683V5.99967L9.3335 1.33301L10.1668 2.16634C10.2446 2.24412 10.3085 2.34967 10.3585 2.48301C10.4085 2.61634 10.4335 2.74412 10.4335 2.86634V3.09967L9.70016 5.99967H14.0002C14.3557 5.99967 14.6668 6.13301 14.9335 6.39967C15.2002 6.66634 15.3335 6.97745 15.3335 7.33301V8.66634C15.3335 8.74412 15.3224 8.82745 15.3002 8.91634C15.2779 9.00523 15.2557 9.08856 15.2335 9.16634L13.2335 13.8663C13.1335 14.0886 12.9668 14.2775 12.7335 14.433C12.5002 14.5886 12.2557 14.6663 12.0002 14.6663ZM6.00016 13.333H12.0002L14.0002 8.66634V7.33301H8.00016L8.90016 3.66634L6.00016 6.56634V13.333ZM4.66683 5.99967V7.33301H2.66683V13.333H4.66683V14.6663H1.3335V5.99967H4.66683Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/Thumbs Up.9aa2f28d7df1ded4db0561d39b269d2b.svg";
export { ForwardRef as ReactComponent };